import React from "react";
import PaidCompany from "../PaidCompany";

const PaidCompanyComponent = () => {
  return <PaidCompany status="class-allocated" title="class-allocated" />;
};

export default PaidCompanyComponent;
